import { Swiper, Navigation, Keyboard, Mousewheel } from 'swiper'
Swiper.use(Navigation)
Swiper.use(Keyboard)
Swiper.use(Mousewheel)
import { breakpoints } from '../../application/utils/breakpoints'

export function createSwiper(swiperElement) {
  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 10,
    mousewheel: {
      forceToAxis: true
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    navigation: {
      prevEl: swiperElement
        .closest('section')
        .querySelector('.swiper-buttons button[data-prev]'),
      nextEl: swiperElement
        .closest('section')
        .querySelector('.swiper-buttons button[data-next]')
    },
    breakpoints: {
      [breakpoints.small + 1]: {
        slidesPerView: 3
      },
      [breakpoints.smallest + 1]: {
        slidesPerView: 2
      }
    }
  })
}

export function destroySwiper(swiperElement) {
  if (swiperElement.swiper) {
    swiperElement.swiper.destroy(true, true)
    setTimeout(() => {
      swiperElement
        .querySelectorAll('.swiper-slide')
        .forEach((slide) => (slide.style = ''))
    })
  }
}
